<!-- 入力画面ダイアログ -->
<p-dialog [header]="title" [(visible)]="inputModal" [modal]="true" [resizable]="false" (onHide)="onHidden.emit()">
  <!-- 入力情報 -->
  <app-generate-input-information
    (reloadID)="return($event)"
  ></app-generate-input-information>
</p-dialog>
